import {
	ADMIN_INIT_NEW_ANALYSISLIBRARY,
	ADMIN_RESET_FOCUS_ANALYSISLIBRARY,
	API_GET_ALL_ANALYSISLIBRARY,
	API_GET_ANALYSES_COST,
	API_ADMIN_GET_ALL_ANALYSISLIBRARY,
	API_ADMIN_DELETE_ANALYSISLIBRARY,
	API_ADMIN_GET_ANALYSISLIBRARY,
	API_ADMIN_PATCH_ANALYSISLIBRARY,
	API_GET_MATCHING_ANALYSES,
	RESET_COSTS,
	API_GET_ANALYSIS_BY_CATALOG_CODE,
	API_GET_ANALYSIS_AES_ERRORS,
} from "../actions/analysisLibrary";
import { API_ADMIN_POST_ANALYSISLIBRARY } from "actions/analysisLibrary";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_ADMIN_GET_ALL_ANALYSISLIBRARY]: {
		default: "/admin/analysesLibrary",
		v2: "/analysis-library",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_ANALYSISLIBRARY]: {
		default: (analysisId) => `/admin/analysesLibrary/${analysisId}`,
		v2: (analysisId) => `/analysis-library/${analysisId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_ANALYSISLIBRARY]: {
		default: "/admin/analysesLibrary",
		v2: "/analysis-library",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_ANALYSISLIBRARY]: {
		default: (analysisId) => `/admin/analysesLibrary/${analysisId}`,
		v2: (analysisId) => `/analysis-library/${analysisId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_ANALYSISLIBRARY]: {
		default: (analysisId) => `/admin/analysesLibrary/${analysisId}`,
		v2: (analysisId) => `/analysis-library/${analysisId}`,
		currentClient: DEFAULT_CLIENT,
	},
	// Proxy endpoint exposed by v7 backend under /api/v7 (see nurse_backend_nestjs/src/external-apis/mylab.controller.ts)
	[API_GET_ANALYSES_COST]: {
		default: () => `/analysesLibrary/costs`,
		v2: () => `/analysesLibrary/costs`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function getAnalysisLibrary(isHome, folderId, patientId, prescriberId, center) {
	return {
		type: API_GET_ALL_ANALYSISLIBRARY,
		payload: {
			request: {
				url: `/analysesLibrary`,
				params: {
					home: isHome,
					folderId: folderId,
					patientId: patientId,
					prescriberId: prescriberId,
					center: center,
					limit: process.env.REACT_APP_TOP_ANALYSES_LIMIT,
				},
			},
		},
	};
}

// Retrieve a list of analysis' id by sending a list of catalog codes
export function getMatchingAnalyses(catalogCodes, pi = false) {
	return {
		type: API_GET_MATCHING_ANALYSES,
		payload: {
			request: {
				url: `/analysisLibrary/matching`,
				params: {
					catalogCodes,
					pi,
				},
			},
		},
	};
}

export function adminGetAnalysisLibrary(analysisLibrary) {
	const version = getVersion(API_ADMIN_GET_ANALYSISLIBRARY);
	const url = typeof version.path === 'function' ? version.path(analysisLibrary.id) : version.path;
	return {
		type: API_ADMIN_GET_ANALYSISLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminGetAllAnalysisLibrary() {
	const version = getVersion(API_ADMIN_GET_ALL_ANALYSISLIBRARY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_ANALYSISLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminPostAnalysisLibrary(analysisLibrary) {
	const version = getVersion(API_ADMIN_POST_ANALYSISLIBRARY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_POST_ANALYSISLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: analysisLibrary,
			},
		},
	};
}

export function adminPatchAnalysisLibrary(analysisLibrary) {
	const version = getVersion(API_ADMIN_PATCH_ANALYSISLIBRARY);
	const url = typeof version.path === 'function' ? version.path(analysisLibrary.id) : version.path;
	return {
		type: API_ADMIN_PATCH_ANALYSISLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: analysisLibrary,
			},
		},
	};
}

export function adminDeleteAnalysisLibrary(analysisLibrary) {
	const version = getVersion(API_ADMIN_DELETE_ANALYSISLIBRARY);
	const url = typeof version.path === 'function' ? version.path(analysisLibrary.id) : version.path;
	return {
		type: API_ADMIN_DELETE_ANALYSISLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "DELETE",
			},
		},
	};
}

export function initNewAnalysisLibrary() {
	return {
		type: ADMIN_INIT_NEW_ANALYSISLIBRARY,
	};
}

export function resetFocusAnalysisLibrary() {
	return {
		type: ADMIN_RESET_FOCUS_ANALYSISLIBRARY,
	};
}

export function resetCosts() {
	return {
		type: RESET_COSTS,
	};
}

export function getFolderAnalysesCost(data) {
	const version = getVersion(API_GET_ANALYSES_COST);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_ANALYSES_COST,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: data,
			},
		},
	};
}

export function getAnalysisByCatalogCode(catalog_code) {
	return {
		type: API_GET_ANALYSIS_BY_CATALOG_CODE,
		payload: {
			request: {
				url: `/analysesLibrary/${catalog_code}`,
			},
		},
	};
}

export function getAnalysisAESErrors() {
	return {
		type: API_GET_ANALYSIS_AES_ERRORS,
		payload: {
			request: {
				url: `/analysesLibrary/aes/errors`,
			},
		},
	};
}
